<div class="profile-layout reverse">
    <div class="profile-layout-content">
        <app-applicant-documents [applicant]="applicant"></app-applicant-documents>
        <app-links-card [applicant]="applicant"></app-links-card>
    </div>
    <div class="profile-layout-sidebar"><app-comments-mini></app-comments-mini></div>
</div>
